import { browser } from '$app/environment';

const _scriptsLoaded = new Set();
const _scriptsLoading = new Map();

function injectScript(src: string) {
  return new Promise<void>((resolve, reject) => {
    // script has been loaded in the past or is currently loading
    if (_scriptsLoaded.has(src)) {
      return resolve();
    }
    if (_scriptsLoading.has(src)) {
      return _scriptsLoading.get(src).then(() => resolve());
    }

    // add the script to our loading map
    let done: (value?: unknown) => void;
    _scriptsLoading.set(
      src,
      new Promise(resolve => {
        done = resolve;
      })
    );
    _scriptsLoading.get(src).then(() => _scriptsLoading.delete(src));

    // inject the script
    const element = document.createElement('script');
    element.async = true;
    element.src = src;
    element.onload = () => {
      _scriptsLoaded.add(src);
      done();
      resolve();
    };
    element.onerror = () => {
      done();
      reject();
    };
    document.head.appendChild(element);
  });
}

export function includeScript(src: string) {
  if (browser) {
    return injectScript(src);
  } else {
    return Promise.resolve();
  }
}
